<script setup lang="ts">
import Button from '~/components/design-system/button.vue';

const settings = useSiteStore();

const handleConfirm = () => {
  settings.deactivateModal();
  settings.activateModal('register');
};

const handleDecline = () => {
  settings.setDemoPlayTimeout();
  settings.deactivateModal();
};

onMounted(() => settings.clearDemoPlayTimeout());
</script>

<template>
  <div class="p-4 flex flex-col gap-2 text-center">
    <p class="text-dark-900 dark:text-light-50">
      {{ $t('enjoying-the-game') }}
    </p>
    <p class="text-dark-900 dark:text-light-50">
      {{ $t('suggest-play-for-real') }}
    </p>
  </div>
  <div class="flex flex-col gap-4 p-4 bg-base w-full">
    <Button type="primary" class="w-full justify-center" @click="handleConfirm">
      {{ $t('register') }}
    </Button>
    <Button
      type="secondary-alternative"
      class="w-full justify-center"
      @click="handleDecline"
    >
      {{ $t('continue-demo-play') }}
    </Button>
  </div>
</template>
